<div class="d-flex flex-column justify-content-center message">
  <span class="message__content" [innerHTML]="this.data.message | translate"></span>
</div>
